import { EnvironmentMetadata } from '@/react/portainer/environments/environment.service/create';

import { Option } from '@@/form-components/Input/Select';

import { K8sDistributionType } from '../../../types';

export type ProvisionOption = K8sDistributionType;

export type AddonOptionInfo = {
  versionAvailableFrom: string;
  versionAvailableTo: string;
  repository: string;

  tooltip?: string;
  info?: string;
  version?: string;
  placeholder?: string;
  isDefault: boolean;
} & Option<string>;

export interface BaseK8sInstallFormValues {
  credentialId: number;
  name: string;
  meta: EnvironmentMetadata;
}

export const k8sInstallTitles: Record<K8sDistributionType, string> = {
  omni: 'Sidero Omni',
};
